(() => {
  const MENU_ID = 'licohenna-fullscreen-menu';
  const OPEN_CLASS = 'licohenna-menu-open';
  const LOCK_CLASS = 'licohenna-menu-lock';
  const NAV_HOLD_CLASS = 'licohenna-nav-hold';
  const HEADER_GROUP_SELECTOR = '#shopify-section-group-header-group, .shopify-section-group-header-group';
  const SCROLLBAR_PROP = '--licohenna-scrollbar-compensation';
  const FADE_MS = 450;
  const NAV_HOLD_MS = 400;
  const PRESTIGE_HIDE_DELTA = 100;

  let lastTrigger = null;
  let closeFade = null;
  let menuIsOpen = false;
  let openRaf = 0;
  let navHoldTimer = 0;

  const getMenu = () => document.getElementById(MENU_ID);
  const getOpenTriggers = () => Array.from(document.querySelectorAll('[data-licohenna-menu-open]'));
  const getCloseTriggers = () => Array.from(document.querySelectorAll('[data-licohenna-menu-close]'));
  const getAllTriggers = () => getOpenTriggers().concat(getCloseTriggers());
  const isOpen = () => menuIsOpen;

  const syncClosePosition = () => {
    const openTrigger = getOpenTriggers().find(isVisible) || getOpenTriggers()[0];
    const closeTrigger = getCloseTriggers()[0];
    const header = document.querySelector('x-header.licohenna-header');
    if (!openTrigger || !closeTrigger || !header) return;

    const headerRect = header.getBoundingClientRect();
    const triggerRect = openTrigger.getBoundingClientRect();
    closeTrigger.style.top = `${triggerRect.top - headerRect.top}px`;
    closeTrigger.style.left = `${triggerRect.left - headerRect.left}px`;
    closeTrigger.style.right = 'auto';
    closeTrigger.style.width = `${triggerRect.width}px`;
    closeTrigger.style.height = `${triggerRect.height}px`;
  };

  const isVisible = (el) => {
    if (!el) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  };

  const setInert = (on) => {
    const menu = getMenu();
    Array.from(document.body.children).forEach((el) => {
      if (el === menu) return;
      if (el.matches && el.matches(HEADER_GROUP_SELECTOR)) return;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
      if (on) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });

    document.querySelectorAll('.shopify-section--announcement-bar').forEach((el) => {
      if (on) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });
  };

  const getScrollbarWidth = () => Math.max(0, window.innerWidth - document.documentElement.clientWidth);

  const isInsideMenu = (target) => {
    const menu = getMenu();
    return !!(menu && target && menu.contains(target));
  };

  const onLockWheel = (event) => {
    if (isInsideMenu(event.target)) {
      const menu = getMenu();
      const goingUp = event.deltaY < 0;
      const goingDown = event.deltaY > 0;
      if (goingUp && menu.scrollTop > 0) return;
      if (goingDown && menu.scrollTop + menu.clientHeight < menu.scrollHeight - 1) return;
    }
    event.preventDefault();
  };

  const onLockTouchMove = (event) => {
    if (isInsideMenu(event.target)) return;
    event.preventDefault();
  };

  const onLockScrollKey = (event) => {
    if (!['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'].includes(event.key)) return;
    if (isInsideMenu(event.target)) return;
    event.preventDefault();
  };

  const lockScroll = () => {
    const root = document.documentElement;
    root.style.setProperty(SCROLLBAR_PROP, `${getScrollbarWidth()}px`);
    root.classList.add(LOCK_CLASS);
    window.addEventListener('wheel', onLockWheel, { passive: false });
    window.addEventListener('touchmove', onLockTouchMove, { passive: false });
    document.addEventListener('keydown', onLockScrollKey);
  };

  const unlockScroll = () => {
    const root = document.documentElement;
    root.classList.remove(LOCK_CLASS);
    root.style.removeProperty(SCROLLBAR_PROP);
    window.removeEventListener('wheel', onLockWheel);
    window.removeEventListener('touchmove', onLockTouchMove);
    document.removeEventListener('keydown', onLockScrollKey);
  };

  const getFocusables = (menu) => {
    const items = [];
    const logo = document.querySelector('.licohenna-header .header__logo a, a.licohenna-header.header__logo, .licohenna-header a.header__logo');

    if (logo && isVisible(logo)) {
      items.push(logo);
    }

    menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])').forEach((el) => {
      if (isVisible(el)) items.push(el);
    });

    return items;
  };

  const cancelCloseFade = (menu) => {
    if (!closeFade) return;
    menu.removeEventListener('transitionend', closeFade.onEnd);
    window.clearTimeout(closeFade.timer);
    closeFade = null;
  };

  const cancelOpenRaf = () => {
    if (!openRaf) return;
    window.cancelAnimationFrame(openRaf);
    openRaf = 0;
  };

  const willPrestigeHideOnUnlock = () => window.scrollY > PRESTIGE_HIDE_DELTA;

  const clearNavHold = () => {
    if (navHoldTimer) {
      window.clearTimeout(navHoldTimer);
      navHoldTimer = 0;
    }
    document.documentElement.classList.remove(NAV_HOLD_CLASS);
  };

  const applyOpenClass = () => {
    openRaf = 0;
    document.documentElement.classList.add(OPEN_CLASS);
    syncClosePosition();
  };

  const open = (trigger, menu) => {
    lastTrigger = trigger || getOpenTriggers()[0] || null;
    cancelCloseFade(menu);
    cancelOpenRaf();
    clearNavHold();
    menuIsOpen = true;
    menu.hidden = false;
    menu.setAttribute('aria-hidden', 'false');
    lockScroll();
    syncClosePosition();
    setInert(true);

    getAllTriggers().forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });

    menu.offsetWidth;
    openRaf = window.requestAnimationFrame(() => {
      openRaf = window.requestAnimationFrame(applyOpenClass);
    });
  };

  const finishClose = (menu, { restoreFocus = true } = {}) => {
    cancelCloseFade(menu);
    if (menu.hidden) return;
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');

    const hideAfterUnlock = willPrestigeHideOnUnlock();

    unlockScroll();
    setInert(false);

    getAllTriggers().forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    if (restoreFocus && lastTrigger) {
      lastTrigger.focus({ preventScroll: true });
    } else if (lastTrigger && document.activeElement === lastTrigger) {
      lastTrigger.blur();
    }

    if (hideAfterUnlock) {
      navHoldTimer = window.setTimeout(clearNavHold, NAV_HOLD_MS);
    } else {
      clearNavHold();
    }
  };

  const close = (menu, options = {}) => {
    if (!isOpen()) return;

    menuIsOpen = false;
    cancelOpenRaf();
    if (willPrestigeHideOnUnlock()) {
      document.documentElement.classList.add(NAV_HOLD_CLASS);
    }
    const hasOpenClass = document.documentElement.classList.contains(OPEN_CLASS);
    document.documentElement.classList.remove(OPEN_CLASS);

    if (!hasOpenClass) {
      finishClose(menu, options);
      return;
    }

    const onEnd = (event) => {
      if (event.target !== menu || event.propertyName !== 'opacity') return;
      finishClose(menu, options);
    };

    closeFade = {
      onEnd,
      timer: window.setTimeout(() => finishClose(menu, options), FADE_MS + 80),
    };
    menu.addEventListener('transitionend', onEnd);
  };

  const init = () => {
    const menu = getMenu();
    const openTriggers = getOpenTriggers();
    const closeTriggers = getCloseTriggers();
    if (!menu || openTriggers.length === 0) return;

    openTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-controls', MENU_ID);
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (!isOpen()) open(trigger, menu);
      });
    });

    closeTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-controls', MENU_ID);
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (isOpen()) close(menu, { restoreFocus: event.detail === 0 });
      });
    });

    menu.addEventListener('click', (event) => {
      if (!isOpen()) return;
      const link = event.target.closest('a[href]');
      if (!link || !menu.contains(link)) return;
      // Reuse × close path; keep default navigation / new-tab behavior.
      close(menu, { restoreFocus: false });
    });

    window.addEventListener('resize', () => {
      if (isOpen()) syncClosePosition();
    });

    document.addEventListener('keydown', (event) => {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close(menu, { restoreFocus: true });
        return;
      }

      if (event.key !== 'Tab') return;

      const items = getFocusables(menu);
      if (items.length === 0) return;

      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && (active === first || !menu.contains(active) && active !== first && !items.includes(active))) {
        event.preventDefault();
        last.focus();
        return;
      }

      if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
